import $ from 'jquery';

$.fn.breakingNews = function (options) {
    const settings = $.extend({
        timeout: 5000,
        itemSelector: '.breaking--item',
    }, options);
    let _this = this;

    function getTotalItems() {
        return $(_this).find(settings.itemSelector).length;
    }

    setInterval(() => {
        let _activeItem = $(_this).find(settings.itemSelector + '.active');
        let _nextItem = _activeItem.next();
        if (!_nextItem.length) {
            _nextItem = $(_this).find(settings.itemSelector).first();
        }
        _activeItem.stop().slideUp('fast', function () {
            $(this).removeClass('active')
            _nextItem.stop().slideDown('fast', function () {
                $(this).addClass('active')
            });
        });

    }, settings.timeout);

};


export default class BreakingNews {
    constructor(selector, options = {}) {
        if ($(selector).length === 0) {
            return;
        }
        $(selector).breakingNews(options)
    }
}



// WEBPACK FOOTER //
// ./src/scripts/breakingNews.js